import * as z from "zod/v4";

export const updateBillingSettings = {
  name: "updateBillingSettings" as const,
  input: z.object({
    teamId: z.string(),
    billingAutomation: z.enum(["auto", "manual"]),
    manualBillingDueInDays: z.number().int().min(1).max(365),
    billingFailureMode: z.enum(["allow", "restrict"]),
    returnsBillingSchedule: z.enum(["bimonthly", "weekly", "monthly"]),
    billingDayOfMonth: z.number().int().min(1).max(28),
    billingDayOfWeek: z.number().int().min(0).max(6),
    billingMonthOfYear: z.number().int().min(1).max(12),
  }),
  output: z.object({ success: z.boolean() }),
};
